module.exports = {
      id: "facebook-circular-plain-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-5579a9c22c9b0e56875750544888299d.svg#facebook-circular-plain",
      toString: function () {
        return this.url;
      }
    }